import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth.store';
import { ReviewsDashboardPanel } from '@/components/organisms/reviews-dashboard/ReviewsDashboardPanel';

/**
 * Reviews Dashboard (spec §12).
 *
 * Permission gate: callers without `reviews:view` get redirected home — this
 * mirrors the spec §12.7 default that techs only see their own reviews
 * (which the backend enforces via tenant + permission checks; we redirect
 * away from the admin dashboard view here).
 */
export const Route = createFileRoute('/_dashboard/dashboard/reviews')({
  beforeLoad: () => {
    const { permissions } = useAuthStore.getState();
    if (permissions.length > 0 && !permissions.includes('reviews:view')) {
      throw redirect({ to: '/dashboard/home' });
    }
  },
  component: ReviewsPage,
});

function ReviewsPage() {
  return (
    <div className="min-h-full pb-8">
      <ReviewsDashboardPanel />
    </div>
  );
}
